import { render } from "./SelectFrenteLoja.vue?vue&type=template&id=4789ec0e&scoped=true"
import script from "./SelectFrenteLoja.vue?vue&type=script&lang=js"
export * from "./SelectFrenteLoja.vue?vue&type=script&lang=js"

import "./SelectFrenteLoja.vue?vue&type=style&index=0&id=4789ec0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4789ec0e"]])

export default __exports__